<template>
  <div>
    <template v-for="recovery in shoppingRecoveryList" :key="recovery.trigger">
      <ShoppingRecoveryNone
        v-if="recovery.type === 'modal'"
        :recovery="recovery" />
      <ShoppingRecoveryNewsletter
        v-if="recovery.type === 'newsletter'"
        :recovery="recovery" />
      <ShoppingRecoveryPromotion
        v-if="recovery.type === 'promotion'"
        :recovery="recovery" />
    </template>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import ShoppingRecoveryNone from './ShoppingRecoveryNone.vue';
import ShoppingRecoveryNewsletter from './ShoppingRecoveryNewsletterSubscription.vue';
import ShoppingRecoveryPromotion from './ShoppingRecoveryPromotion.vue';
import { useShoppingRecoveryStore } from '@/stores/shoppingRecovery.store.js';

const store = useShoppingRecoveryStore();
const { shoppingRecoveryList } = storeToRefs(store);
</script>
